import { render, staticRenderFns } from "./worker-expenses.vue?vue&type=template&id=aea4077e&scoped=true&"
import script from "./worker-expenses.vue?vue&type=script&lang=js&"
export * from "./worker-expenses.vue?vue&type=script&lang=js&"
import style0 from "./worker-expenses.vue?vue&type=style&index=0&id=aea4077e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea4077e",
  null
  
)

component.options.__file = "worker-expenses.vue"
export default component.exports